module.exports = __webpack_public_path__ + "img/fast_eller_rorligt@3x.8f06e649.jpg";